import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SignupComponent } from './signup/signup.component';
import { LoginComponent } from './login/login.component';
import { authGuard } from './core/guards';
import { roleGuard } from './core/guards/role.guard';
import { TestComponent } from './test/test.component';
import { LoginGuard } from './core/guards/login.guard';
import { PublicNivedanComponent } from './shared/public-nivedan/public-nivedan.component';
//import { adminAuthGuard } from './core/guards/admin-auth.guard';

const routes: Routes = [
  {
    path: 'guestUser/:id',
    component: PublicNivedanComponent
  },
  {
    path: '',
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'test',
        component: TestComponent,
      },
      {
        path: 'signup',
        component: SignupComponent,
      },
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [LoginGuard]
      },
      {
        path: 'super-admin',
        loadChildren: () =>
          import('./super-admin/super-admin.module').then(
            (m) => m.SuperAdminModule
          ),
      },
      {
        path: 'admin',
        canActivate: [authGuard],
        loadChildren: () =>
          import('./admin/admin.module').then((m) => m.AdminModule),
      },
      { path: '**', redirectTo: '' },
    ],
  },


];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
